import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "尺寸：", -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "分类：", -1);
const _hoisted_3 = {
  key: 0,
  class: "flex flex-wrap gap-2 mt-2"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 1,
  class: "flex flex-wrap gap-2 mt-2"
};
const _hoisted_6 = ["src"];
import OssUploader from '@/components/OssUploader.vue';
import axios from 'axios';
import { onMounted, ref } from 'vue';
import icons from './icons.json';
export default {
  __name: 'IconSelector',
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const scales = ['x45', 'x75', 'x100'];
    const scale = ref('x100');
    const folder = ref(Object.keys(icons)[0]);
    const handleUploadSuccess = ({
      url,
      client
    }) => {
      const list = [url, ...icons.value];
      const content = JSON.stringify(list);
      const file = new Blob([content], {
        type: 'application/json'
      });
      client.put('/icons.json', file);
      emit('select', url);
    };
    const props = __props;
    onMounted(async () => {
      // const res = await axios({
      //   url: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/icons.json',
      // })
      // icons.value = res.data
    });
    return (_ctx, _cache) => {
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", null, [_hoisted_1, _createVNode(_component_el_radio_group, {
        modelValue: scale.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => scale.value = $event),
        onChange: _cache[1] || (_cache[1] = $event => scale.value = $event),
        size: "small"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(scales, item => {
          return _createVNode(_component_el_radio_button, {
            key: item,
            label: item,
            value: item
          }, null, 8, ["label", "value"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", null, [_hoisted_2, _createVNode(_component_el_radio_group, {
        modelValue: folder.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => folder.value = $event),
        onChange: _cache[3] || (_cache[3] = $event => folder.value = $event),
        size: "small"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(icons)), item => {
          return _openBlock(), _createBlock(_component_el_radio_button, {
            key: item,
            label: item,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createTextVNode(" " + _toDisplayString(folder.value) + _toDisplayString(scale.value) + " ", 1), __props.editMode ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(icons)[folder.value][scale.value], (icon, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: icon
        }, [index < 16 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: $event => emit('select', icon)
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: icon,
            alt: "icon",
            class: "w-5 h-5 object-contain"
          }, null, 8, _hoisted_4)]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(icons)[folder.value][scale.value], icon => {
        return _openBlock(), _createElementBlock("div", {
          key: icon
        }, [_createVNode(_component_el_button, {
          onClick: $event => emit('select', icon)
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: icon,
            alt: "icon",
            class: "w-5 h-5 object-contain"
          }, null, 8, _hoisted_6)]),
          _: 2
        }, 1032, ["onClick"])]);
      }), 128))]))]);
    };
  }
};